<template>
  <div>
    <div class="row">
      <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-2">
        <fg-input
          type="text"
          :label="`${$t('common_words.code')}: *`"
          v-model="model.group_code"
          name="common_words.code"
          v-validate="modelValidations.code"
          :error="getError('common_words.code', true)"
          placeholder="..."
          @click="handleClickOnCode()"
        ></fg-input>
      </div>
      <div class="col-12 col-sm-6 col-md-6 col-lg-8 col-xl-10">
        <fg-input
          type="text"
          :label="`${$t('common_words.name')}: *`"
          v-model="model.group_name"
          name="common_words.name"
          v-validate="modelValidations.name"
          :error="getError('common_words.name', true)"
          placeholder="..."
          @blur="convertUppercase(model.group_name)"
        >
        </fg-input>
      </div>
      <div class="col-12">
        <select-businesses-component
          ref="selectBusiness"
          :showLoading="false"
          :requiered="true"
          @onChange="updateSelectedBusinesses"
          @showHideLoading="showHideLoading"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-6">
        <div class="form-group has-label">
          <label>{{ $t('common_words.select_associated_profiles') }} </label>
          <br />
          <el-select
            collapse-tags
            @change="selectAllFromSelect('model.roles_id', availableRoles)"
            multiple
            clearable
            filterable
            class="select-primary custom-width-select shadow-sm"
            size="large"
            v-model="model.roles_id"
            :placeholder="`${$t('common_words.select')}...`"
          >
            <el-option
              v-for="option in availableRoles"
              class="select-primary selected-all"
              :value="option.id"
              :label="option.name"
              :key="option.id"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div class="form-group has-label">
          <label>{{ $t('common_words.select_associated_users') }} </label>
          <br />
          <el-select
            collapse-tags
            @change="selectAllFromSelect('model.users_id', availableUsers)"
            multiple
            clearable
            filterable
            class="select-primary custom-width-select shadow-sm"
            size="large"
            v-model="model.users_id"
            :placeholder="`${$t('common_words.select')}...`"
          >
            <el-option
              v-for="option in availableUsers"
              class="select-primary selected-all"
              :value="option.id"
              :label="`${option.name}`"
              :key="option.id"
            ></el-option>
          </el-select>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset, convertFirstLetterUppercase } from 'src/util/Util';
import Businesses from 'src/components/Selects/Businesses.vue';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinValidations from 'src/mixins/forms/mixin-validations.js';

export default {
  components: {
    [Businesses.name]: Businesses,
  },

  data() {
    return {
      model: {
        id: null,
        group_name: null,
        group_code: null,
        businesses_id: [],
        businesses_names: [],
        roles_id: [],
        users_id: [],
        roles_name: [],
        users_name: [],
      },
      modelValidations: {
        name: { required: true },
        code: { required: true },
      },
      businesses: [],
      roles: [],
      users: [],
    };
  },
  mixins: [
    MixinPermissions,
    MixinForm,
    MixinAlert,
    MixinLoading,
    MixinValidations,
  ],
  computed: {
    availableRoles() {
      const tmp = [...this.model.roles_id];
      if (this.model.businesses_id.length > 0) {
        this.model.roles_id = [];
        const response = this.roles.filter((rol) => {
          const businessAffiliates = rol.business.filter((bs) =>
            this.model.businesses_id.includes(bs.id)
          );
          return businessAffiliates.length > 0;
        });

        response.forEach((rol) => {
          if (tmp.includes(0)) this.model.roles_id.push(rol.id);
          else if (tmp.includes(rol.id)) this.model.roles_id.push(rol.id);
        });

        return this.concatAll(response);
      } else return this.concatAll([]);
    },
    availableUsers() {
      const tmp = [...this.model.users_id];
      if (this.model.businesses_id.length > 0) {
        this.model.users_id = [];
        const response = this.users.filter((user) => {
          const businessAffiliates = user.business.filter((bs) =>
            this.model.businesses_id.includes(bs.id)
          );
          return businessAffiliates.length > 0;
        });

        response.forEach((user) => {
          if (tmp.includes(0)) this.model.users_id.push(user.id);
          else if (tmp.includes(user.id)) this.model.users_id.push(user.id);
        });

        return this.concatAll(response);
      } else return this.concatAll([]);
    },
  },
  methods: {
    convertUppercase(groupName) {
      const name = convertFirstLetterUppercase(groupName);
      this.model.group_name = name;
    },
    handleClickOnCode() {
      const tableCodes = Object(
        JSON.parse(sessionStorage.getItem('tableCode'))
      );

      if (
        !isset(this.model.group_code) &&
        !sessionStorage.getItem('editForm')
      ) {
        this.codeGenerator('Grupo Actividades', tableCodes, 'group_code');
      }
    },
    updateSelectedBusinesses(data) {
      const bsSelected = data.associations_ids.concat(data.businesses_ids);
      this.$set(this.model, 'businesses_id', bsSelected);
      this.$set(this.model, 'businesses_names', data.names);
    },
    opty(dataMain, options) {
      const others = [];
      dataMain.forEach((element) => {
        const isFind = options.find((item) => item.id === element);
        if (isFind) others.push(isFind.name);
      });

      return others;
    },
    validate() {
      return this.$validator
        .validateAll()
        .then((res) => {
          this.$emit('on-validated', {
            ...this.model,
            names_business: this.businesses
              .filter((business) =>
                this.model.businesses_id.includes(business.id)
              )
              .map((business) => business.name),
            roles_name: this.opty(this.model.roles_id, this.roles),
            users_name: this.opty(this.model.users_id, this.users),
          });

          return res;
        })
        .then((resp) => {
          if (!resp) return resp;

          if (!isset(this.model.businesses_id)) {
            return this.validationInputsRequired('bus-rels');
          } else return true;
        });
    },
  },

  created() {
    this.showHideLoading(true);
    if (this.isCreate() || this.isUpdate()) {
      Promise.all([
        Axios.getMasters('roles/indexfield'),
        Axios.getMasters('users/indexfield'),
      ])
        .then((response) => {
          const [response_roles, response_users] = response;
          this.roles = response_roles.data.data;
          this.users = response_users.data.data;

          const editForm = sessionStorage.getItem('editForm');
          if (this.isUpdate() && editForm) {
            const {
              id,
              group_id,
              name: group_name,
              code: group_code,
              roles,
              users,
            } = JSON.parse(editForm);
            this.model = {
              ...this.model,
              id,
              group_id,
              group_name,
              group_code,
              roles_id: roles.map((r) => r.id),
              users_id: users.map((u) => u.id),
            };
          }

          setTimeout(() => {
            this.showHideLoading();
          }, 1000);
        })
        .catch((error) => this.showMessageErrors(error));
    } else this.showHideLoading();
  },
};
</script>
<style></style>
